import React from 'react';

const Footer = () => {
    const footerLinks = {
        products: {
            title: 'PRODUCTS',
            links: [
                { name: 'Integrations', href: '#' },
                { name: 'Analytics', href: '#' },
                { name: 'Workspace', href: '#' },
                { name: 'Embed Charts', href: '#' },
                { name: 'DataStudio', href: '#' },
                { name: 'Google add-on', href: '#' },
                { name: 'Pricing', href: '#' },
            ]
        },
        resources: {
            title: 'RESOURCES',
            links: [
                { name: 'Blog', href: '#' },
                { name: 'Changelog', href: '#' },
                { name: 'Affiliate Program', href: '#' },
                { name: 'Knowledge base', href: '#' },
                { name: 'Contact us', href: '#' },
            ]
        },
        legal: {
            title: 'LEGAL',
            links: [
                { name: 'Privacy policy', href: '#' },
                { name: 'Terms & Conditions', href: '#' },
            ]
        }
    };

    const socialLinks = [
        { name: 'X', href: '#', icon: '/footer/x.png' },
        { name: 'LinkedIn', href: '#', icon: '/footer/linkedin.png' },
        { name: 'Instagram', href: '#', icon: '/footer/insta.png' },
        { name: 'Facebook', href: '#', icon: '/footer/facebook.png' },
    ];

    return (
        <footer className="bg-[#F5F7FA] pt-16">
            <div className="max-w-7xl mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Logo and Social Links */}
                    <div className="space-y-4">
                        <div className="text-xl font-bold">SuperMetrics.com</div>
                        <div className="flex space-x-4">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.href}
                                    className="hover:opacity-75 transition-opacity"
                                >
                                    <img
                                        src={social.icon}
                                        alt={social.name}
                                        className="w-6 h-6"
                                    />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Footer Link Columns */}
                    {Object.entries(footerLinks).map(([key, section]) => (
                        <div key={key}>
                            <h3 className="text-sm font-medium text-gray-400 mb-4 geist-mono">
                                {section.title}
                                <div className="border-t-2 border-dotted border-gray-200 w-full my-4"></div>
                            </h3>
                            <ul className="space-y-3">
                                {section.links.map((link) => (
                                    <li key={link.name}>
                                        <a
                                            href={link.href}
                                            className="text-gray-600 hover:text-gray-900 text-sm"
                                        >
                                            {link.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Google Add-on Button */}
                <div className="mt-12 flex justify-end">
                    <a
                        href="/"
                        className="inline-flex items-center px-4 py-2 bg-white rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
                    >
                        <img
                            src="/features/google.svg"
                            alt="Google"
                            className="w-4 h-4 mr-2"
                        />
                        <span className="text-sm font-semibold text-[#036AC6]">Google add-on</span>
                        <svg
                            className="ml-2 w-4 h-4 text-[#036AC6]"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                            />
                        </svg>
                    </a>
                </div>

                {/* Copyright */}
                <div className="mt-12 text-center border-t text-sm text-gray-400">
                    Copyright 2024 © SuperMetrics.com
                </div>
                <span
                  className="text-5xl lg:text-9xl mx-auto flex justify-center items-center font-bold bg-clip-text text-transparent"
                  style={{
                    backgroundImage:
                      "linear-gradient(to bottom, #CFD5DE80,#CFD5DE00 )",
                  }}
                >
                  SuperMetrics
                </span>
            </div>
        </footer>
    );
};

export default Footer;